import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const NorthWestIcon = (props: BaseProvinceIconProps) => {
  return (
    <g
      id="NT"
      {...props}
    >
      <path
        d="M65.3,95.6c0.8,0,1.2,0.4,1.4,1.3c0.9,4.9,3.9,8,8.5,9.7c1.6,0.6,3.1,1.5,4.6,2.4c0.9,0.5,1.2,1.7,0.8,2.6
            c-1.2,2.3-2.3,4.5-3.5,6.6c-0.8,1.4-0.7,2.5,0.5,3.7c7.3,7.8,14.6,15.7,21.9,23.6c0.6,0.7,1.5,1.2,2.4,1.4
            c9.1,2.3,18.2,4.5,27.3,6.6c1.4,0.3,1.9,0.9,1.9,2.3c0.2,8.1,0.4,16.2,0.7,24.3c0,1.4-0.3,1.9-1.8,2c-2.6,0.2-5.2,0.8-7.8,0.8
            c-0.2,0-0.3,0-0.5,0c-3.1-0.1-6.1-0.8-9.1-1.3c-10.8-1.9-21.6-3.9-32.4-5.8c-7.6-1.4-15.1-2.7-22.6-4.2c-0.6-0.1-1.3-0.9-1.5-1.5
            c-5-17.2-10-34.5-14.8-51.8c-0.5-1.7,0-3.8,0.2-5.7c0.5-4,1-8,1.5-12.1c0.2-1.2,0.8-1.5,2.5-1.6c6.4-0.3,12.7-1.5,18.9-3.2
            C64.6,95.6,64.9,95.5,65.3,95.6L65.3,95.6z"
      />
      <path
        d="M104.7,52.5c1.2,0,1.7,1.2,2.3,1.9c0.3,0.3,0.3,1.4,0,2c-0.9,1.9-2,3.7-3.1,5.7c-0.4,0.7-1.1,1.2-1.9,1.2
            c-0.2,0-0.3,0-0.5,0c-0.4-0.1-0.7-0.1-1.1-0.1c-1.3,0-2.6,0.5-3.8,1.2c-0.5,0.3-1,0.4-1.4,0.4c-0.8,0-1.4-0.4-2.1-1.2
            c-1.1-1.2-1-3.1,0.3-4.1c1.4-1.1,2.9-2.2,4.2-3.5c1.8-1.7,4-2.5,6.3-3.2C104.3,52.5,104.5,52.5,104.7,52.5L104.7,52.5z"
      />
      <path
        d="M106,75c0.3,0,0.7,0,1.1-0.1c0.1,0,0.3,0.1,0.6,0.2c-0.8,0.7-1.4,1.2-2.1,1.7c-0.3,0.2-0.5,0.4-0.8,0.7
            c-0.7,0.6-0.6,1.7,0.2,2.2c1,0.6,2,1.2,2.9,1.8c0.4,0.3,0.8,0.4,1.2,0.4c0.5,0,0.9-0.2,1.4-0.6c1-0.7,1.9-1.5,2.9-2.2l-0.6-10.3
            c0,0-0.1,0-0.1-0.1c-0.5-0.3-0.9-0.8-1.2-1.5c-0.5-1.1-1.2-2.1-2-3.1c-0.7-0.9-2-1.5-2.9-1.5c-0.4,0-0.7,0.1-0.9,0.3
            c-1.1,1.4-2.2,2.8-3.2,4.2c-0.7,0.9-2.4,2.5-2.4,3.7c0,0.5,0.2,0.9,0.6,1.3C101.9,73.6,103.9,75,106,75L106,75z"
      />
      <path
        d="M95.8,88.2c1.3-0.4,2.6-0.8,3.8-1.3c1.1-0.5,2.4-0.8,1.7-2.2c-0.6-1.2-1.2-2.5-1.8-3.7
            c-0.4-0.8-0.6-1.7-1.1-2.3c-0.7-0.9-1.6-0.7-2.5-1.3c-0.6-0.5-1-1.3-1.5-1.8c-0.6-0.6-1.1-1.5-1.8-1.5c-2.4-0.3-4.8-0.3-7.4-0.4
            c-0.7,0-1.2,0.5-1.2,1.2c0,0.5,0,0.9,0,1.3c0.2,2-0.4,3.7-1.7,5.2c-2.1,2.6-4,5.4-6,8.1c-0.8,1.1-0.8,1.8-0.2,2.9
            c1.1,1.9,2.1,3.9,3,5.8c0.2,0.4,0.6,0.7,1.1,0.7c3.3,0,5.9-1.8,8.1-4.2c1.1-1.2,2-2.7,3.1-3.9C92.7,89.4,94.2,88.7,95.8,88.2
            L95.8,88.2z"
      />
      <path
        d="M112.5,94.5c-1-0.5-2-1.1-3-1.5c-0.9-0.4-1.8-0.8-2.5-1.4c-0.6-0.6-0.6-1.7-1.3-2.3c-0.9-0.7-2.7-0.1-3.6,0.4
            c-0.7,0.3-1.4,0.8-2.2,1C99,91,98.2,91,97.3,91.2c-1.8,0.6-2.7,2.6-3.7,4.1c-0.3,0.4-0.5,1.3-0.2,1.7c1.4,2,1.5,4.1,1.1,6.4
            c-0.2,1,0.2,1.3,1.2,1.5c2.4,0.5,4.8,1,7.2,1.7c0.1,0,0.2,0.1,0.3,0.1c1.1,0.4,0.9,2.1-0.3,2.1c-0.4,0-0.7,0-1.1,0s-0.7,0-1.1,0
            c-1.8,0-3.7-0.1-5.5-0.1c-0.2,0-0.3,0-0.4,0c-0.5,0-1.4,0.3-1.4,0.5s0,0.3,0,0.5l13.9,3.5C107.3,113.2,112.5,94.5,112.5,94.5z"
      />
      <path
        d="M118.5,45.4c0-0.5-0.5-0.9-1-0.9c-0.1,0-0.2,0-0.4,0.1c-1.7,0.7-3.1,1.8-4.4,3.2c-0.6,0.6-0.2,1.5,0.6,1.7
            c1.4,0.2,2.8,0.4,4.2,0.5l1.2-2.9C118.5,46.5,118.5,46,118.5,45.4z"
      />
      <path
        d="M111,55.4c1.2,0.6,2.4,1.2,3.6,1.7l2-5.1c-1.3-0.4-2.6-0.8-3.8-1.3c-0.2,0-0.3-0.1-0.5-0.1
            c-0.7,0-1.3,0.5-1.5,1.2c-0.2,0.8-0.4,1.6-0.5,2.4C110.3,54.6,110.7,55.2,111,55.4z"
      />
    </g>
  );
};
